import { APP_BAR_HEIGHT_DESKTOP, APP_BAR_HEIGHT_MOBILE, Spacing } from "@bonusx-global/bx-design-system";
import { type SwipeableDrawerProps } from "@mui/material/SwipeableDrawer";
import { useMemo } from "react";
import { DEFAULT_ANIMATION_TIME } from "../../chatbot.const";

interface UseChatbotDrawerPropsParams {
  isMobile: boolean;
  isChatbotOpen: boolean;
  handleOpen: SwipeableDrawerProps["onOpen"];
  handleClose: SwipeableDrawerProps["onClose"];
}

export function useChatbotDrawerProps({
  isMobile,
  isChatbotOpen,
  handleOpen,
  handleClose,
}: UseChatbotDrawerPropsParams): SwipeableDrawerProps {
  return useMemo(() => {
    const props = {
      anchor: isMobile ? ("bottom" as const) : ("right" as const),
      open: isChatbotOpen,
      onClose: handleClose,
      transitionDuration: { enter: DEFAULT_ANIMATION_TIME, exit: DEFAULT_ANIMATION_TIME },
      ModalProps: {
        BackdropProps: {
          invisible: !isMobile,
        },
        keepMounted: true,
      },
      PaperProps: {
        sx: {
          width: isMobile ? "100%" : 400,
          maxWidth: "100%",
          boxShadow: "-4px 0 10px rgba(0,0,0,0.1)",
          top: isMobile ? "auto" : APP_BAR_HEIGHT_DESKTOP,
          height: `calc(100dvh - ${isMobile ? APP_BAR_HEIGHT_MOBILE : APP_BAR_HEIGHT_DESKTOP})`,
          borderTopLeftRadius: isMobile ? Spacing[1000] : undefined,
          borderTopRightRadius: isMobile ? Spacing[1000] : undefined,
        },
      },
      variant: isMobile ? "temporary" : "persistent",
    } as const;

    if (isMobile) {
      return {
        ...props,
        onOpen: handleOpen,
      } as SwipeableDrawerProps;
    }

    // TODO: This is actually a DrawerProps
    return props as SwipeableDrawerProps;
  }, [isMobile, isChatbotOpen, handleOpen, handleClose]);
}
